import { Link } from "react-router-dom";

const ORANGE = "#FF5A00";
const BG = "#09090b";
const FG = "#fafafa";

const LOGOS = [
  {
    id: "A",
    name: "Industrial Block",
    note: "Current style, elevated — orange VE tile + heavy wordmark.",
    svg: (
      <svg viewBox="0 0 360 80" className="h-16 w-auto" aria-label="Industrial Block">
        <rect x="0" y="0" width="80" height="80" fill={ORANGE} />
        <text
          x="40"
          y="58"
          textAnchor="middle"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="48"
          fill={BG}
          letterSpacing="2"
        >
          VE
        </text>
        <text
          x="96"
          y="42"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="34"
          fill={FG}
          letterSpacing="3"
        >
          VISION ERA
        </text>
        <text
          x="96"
          y="64"
          fontFamily="Oswald, sans-serif"
          fontSize="11"
          fill="#a1a1aa"
          letterSpacing="6"
        >
          CONSTRUCTION
        </text>
      </svg>
    ),
  },
  {
    id: "B",
    name: "Hex Shield",
    note: "Hexagon industrial badge with stacked wordmark.",
    svg: (
      <svg viewBox="0 0 360 80" className="h-16 w-auto" aria-label="Hex Shield">
        <polygon
          points="40,4 72,22 72,58 40,76 8,58 8,22"
          fill="none"
          stroke={ORANGE}
          strokeWidth="3"
        />
        <text
          x="40"
          y="50"
          textAnchor="middle"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="28"
          fill={ORANGE}
          letterSpacing="2"
        >
          VE
        </text>
        <text
          x="92"
          y="40"
          fontFamily="Oswald, sans-serif"
          fontSize="26"
          fontWeight="700"
          fill={FG}
          letterSpacing="4"
        >
          VISION ERA
        </text>
        <line x1="92" y1="48" x2="180" y2="48" stroke={ORANGE} strokeWidth="2" />
        <text
          x="92"
          y="65"
          fontFamily="Oswald, sans-serif"
          fontSize="10"
          fill="#a1a1aa"
          letterSpacing="6"
        >
          CONSTRUCTION · GTA
        </text>
      </svg>
    ),
  },
  {
    id: "C",
    name: "Chevron Mark",
    note: "Orange chevron stack — feels like rising layers / coats of resin.",
    svg: (
      <svg viewBox="0 0 360 80" className="h-16 w-auto" aria-label="Chevron Mark">
        <polygon points="6,60 36,28 56,28 26,60" fill={ORANGE} />
        <polygon points="34,60 64,28 84,28 54,60" fill={ORANGE} opacity="0.65" />
        <polygon points="62,60 92,28 100,28 70,60" fill={ORANGE} opacity="0.35" />
        <text
          x="118"
          y="42"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="32"
          fill={FG}
          letterSpacing="3"
        >
          VISION ERA
        </text>
        <text
          x="118"
          y="62"
          fontFamily="Oswald, sans-serif"
          fontSize="11"
          fill={ORANGE}
          letterSpacing="6"
        >
          CONSTRUCTION
        </text>
      </svg>
    ),
  },
  {
    id: "D",
    name: "Underline Wordmark",
    note: "Type-only. Clean, premium. Works on white & dark equally.",
    svg: (
      <svg viewBox="0 0 360 80" className="h-16 w-auto" aria-label="Underline Wordmark">
        <text
          x="0"
          y="40"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="40"
          fill={FG}
          letterSpacing="4"
        >
          VISION
        </text>
        <text
          x="148"
          y="40"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="40"
          fill={ORANGE}
          letterSpacing="4"
        >
          ERA
        </text>
        <rect x="0" y="48" width="218" height="3" fill={ORANGE} />
        <text
          x="0"
          y="72"
          fontFamily="Oswald, sans-serif"
          fontSize="11"
          fill="#a1a1aa"
          letterSpacing="8"
        >
          CONSTRUCTION  ·  GTA, CA
        </text>
      </svg>
    ),
  },
  {
    id: "E",
    name: "Diamond Split",
    note: "Rotated square mark with split V/E — modern, distinctive.",
    svg: (
      <svg viewBox="0 0 360 80" className="h-16 w-auto" aria-label="Diamond Split">
        <g transform="translate(40,40) rotate(45)">
          <rect x="-28" y="-28" width="56" height="56" fill={ORANGE} />
          <rect x="-28" y="-28" width="28" height="56" fill={BG} />
        </g>
        <text
          x="22"
          y="48"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="28"
          fill={ORANGE}
          letterSpacing="1"
        >
          V
        </text>
        <text
          x="44"
          y="48"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="28"
          fill={BG}
          letterSpacing="1"
        >
          E
        </text>
        <text
          x="92"
          y="42"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="32"
          fill={FG}
          letterSpacing="3"
        >
          VISION ERA
        </text>
        <text
          x="92"
          y="62"
          fontFamily="Oswald, sans-serif"
          fontSize="11"
          fill="#a1a1aa"
          letterSpacing="6"
        >
          CONSTRUCTION
        </text>
      </svg>
    ),
  },
  {
    id: "F",
    name: "Trowel Mark",
    note: "Custom geometric mark hinting at a trowel / floor surface.",
    svg: (
      <svg viewBox="0 0 360 80" className="h-16 w-auto" aria-label="Trowel Mark">
        <g>
          <rect x="6" y="20" width="68" height="40" fill={ORANGE} />
          <polygon points="6,60 74,60 80,72 0,72" fill={ORANGE} opacity="0.55" />
          <line x1="20" y1="32" x2="60" y2="32" stroke={BG} strokeWidth="2" />
          <line x1="20" y1="42" x2="60" y2="42" stroke={BG} strokeWidth="2" />
          <line x1="20" y1="52" x2="60" y2="52" stroke={BG} strokeWidth="2" />
        </g>
        <text
          x="96"
          y="44"
          fontFamily="Anton, Impact, sans-serif"
          fontSize="32"
          fill={FG}
          letterSpacing="3"
        >
          VISION ERA
        </text>
        <text
          x="96"
          y="64"
          fontFamily="Oswald, sans-serif"
          fontSize="11"
          fill={ORANGE}
          letterSpacing="6"
        >
          CONSTRUCTION
        </text>
      </svg>
    ),
  },
];

export default function LogoPicker() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="eyebrow">Logo Concepts</div>
        <h1 className="font-display text-5xl lg:text-6xl uppercase tracking-wider text-zinc-50 mt-4">
          Pick your favourite.
        </h1>
        <p className="text-zinc-400 mt-4 max-w-xl">
          Six directions for your Vision Era Construction brand mark. Tell me a
          letter (A–F) and I&apos;ll roll it out across the site. Want a tweak —
          different colour, different layout? Say &quot;A but with…&quot;.
        </p>

        <div className="mt-12 space-y-5">
          {LOGOS.map((l) => (
            <div
              key={l.id}
              className="border border-zinc-800 bg-zinc-900 p-8 flex flex-col md:flex-row md:items-center gap-8"
            >
              <div className="md:w-24 shrink-0">
                <div className="font-display text-6xl text-[#FF5A00] tracking-wider">
                  {l.id}
                </div>
              </div>
              <div className="flex-1">{l.svg}</div>
              <div className="md:w-72">
                <div className="font-heading text-xs tracking-[0.3em] uppercase text-zinc-500">
                  Option {l.id}
                </div>
                <div className="font-display text-2xl uppercase tracking-wider text-zinc-50 mt-1">
                  {l.name}
                </div>
                <p className="text-sm text-zinc-400 mt-2 leading-relaxed">
                  {l.note}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/" className="btn-secondary">
            Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
